// Vendor Libs
import { REHYDRATE } from 'redux-persist';

const initialState = {
  error: null,
  fetched: false,
  fetching: false,
};

const actions = {
  AUTHENTICATE_FETCH: (state) => ({ ...state, fetching: true, error: null }),

  AUTHENTICATE_FETCH_FULFILLED: (state, { payload }) => ({
    ...state,
    ...payload,
    fetched: true,
    fetching: false,
  }),

  AUTHENTICATE_FETCH_REJECTED: (state, { error }) => ({
    ...state,
    error,
    fetching: false,
  }),

  AUTHENTICATE_CLEAR_ERROR: (state) => ({ ...state, error: null, fetching: false }),

  AUTHENTICATE_LOGOUT: (_state, { error }) => ({ ...initialState, error }),

  [REHYDRATE]: (state, { payload }) => {
    // Safely access payload.auth using optional chaining
    const auth = payload?.auth;

    // If auth exists and is not fetching, update state accordingly
    return auth && !auth.fetching
      ? { ...auth, error: null, fetching: false, fetched: true }
      : state;
  },
};

const reducer = (state = initialState, action) =>
  actions[action.type] ? actions[action.type](state, action) : state;

export default reducer;
